import { Component, ElementRef, effect, inject } from "@angular/core";

import { ClientService } from "@services";

@Component({ template: "" })
export abstract class AbstractStoppableComponent {
  public readonly eR = inject(ElementRef);
  protected readonly clS = inject(ClientService);

  constructor() {
    effect(() => {
      const classList = this.eR.nativeElement.classList;
      if (this.clS.stop$()) {
        classList.add("stopped");
      } else {
        classList.remove("stopped");
      }
    });
  }
}
